module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"current-status":"Текущий статус","select-status":"Выберите статус из списка","arrived":"Прибыл на завод","unloading":"На разгрузке","unloaded":"Разгружен","sorting":"На сортировке"},"en":{"current-status":"Current status","select-status":"Select status","arrived":"Arrived","unloading":"Unloading","unloaded":"Unloaded","sorting":"Sorting"}}')
  delete Component.options._Ctor
}
